import { makeAutoObservable } from 'mobx';
import { LocalStorageKey } from './LocalStorageKeyRegistry';

export class BookingFeatureStore {
  private _cancellable = false;

  private _cancellableIntoVoucher = false;

  constructor() {
    makeAutoObservable(this);
    this.loadFromStorage();
  }

  set cancellable(cancellable: boolean) {
    this._cancellable = cancellable;
    this.saveToStorage();
  }

  get cancellable(): boolean {
    return this._cancellable;
  }

  set cancellableIntoVoucher(cancellableIntoVoucher: boolean) {
    this._cancellableIntoVoucher = cancellableIntoVoucher;
    this.saveToStorage();
  }

  get cancellableIntoVoucher(): boolean {
    return this._cancellableIntoVoucher;
  }

  private saveToStorage(): void {
    sessionStorage.setItem(
      LocalStorageKey.BOOKING_CANCELLATION_ALLOWED,
      JSON.stringify(!!this._cancellable)
    );

    sessionStorage.setItem(
      LocalStorageKey.BOOKING_CANCELLATION_INTO_VOUCHER_ALLOWED,
      JSON.stringify(!!this._cancellableIntoVoucher)
    );
  }

  private loadFromStorage(): void {
    const isCancellable = sessionStorage.getItem(LocalStorageKey.BOOKING_CANCELLATION_ALLOWED);
    this._cancellable = isCancellable ? JSON.parse(isCancellable) : false;

    const isCancellableIntoVoucher = sessionStorage.getItem(
      LocalStorageKey.BOOKING_CANCELLATION_INTO_VOUCHER_ALLOWED
    );
    this._cancellableIntoVoucher = isCancellableIntoVoucher
      ? JSON.parse(isCancellableIntoVoucher)
      : false;
  }
}
